import { type BaseStocktakeRepository } from "../../_Bases/BaseStocktakeRepository";
import { type LocalDatabaseStocktake } from "../../_Bases/BaseStocktakeRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBStocktakesRepository extends BaseIndexedDBRepository<
    LocalDatabaseStocktake
> implements BaseStocktakeRepository {
    public readonly source: InternalIndexedDBDatabase["stocktakes"];
    protected readonly dataTypeName = "Stocktake";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.stocktakes;
    }
}
